/** "1 sample", "2 samples"; `many` for a plural that is not `one` + "s". */
export const plural = (count: number, one: string, many = `${one}s`): string => `${count} ${count === 1 ? one : many}`
